import { useRef } from 'react';

import {
  ChevronRightIcon,
  Cross1Icon,
  DownloadIcon
} from '@radix-ui/react-icons';
import { Flex, IconButton, Text } from '@raystack/apsara';

import {
  BREADCRUMBS_STAGE_A,
  BREADCRUMBS_STAGE_A_INACTIVE,
  INFERENCE_STAGES
} from '@src/utils/constants/MODE_INFERENCE_DEFAULTS';

import { DownloadInsightsPopup } from '../DownloadInsights';

import styles from './styles.module.css';

export const InsightHeader = ({
  stage,
  onClose,
  onBackButtonClick,
  onModelBackClick,
  activeInsight,
  activeModel
}) => {
  const inputTitle = activeModel?.title ?? null;

  const { name, metadata = {} } = activeInsight;
  const { block_title, date } = metadata;
  const metadataDate = date?.split('-')[0];

  // after 5th, new users will only see name instead of the hacky static naming approach
  const title =
    name || `${block_title}${metadataDate ? ` - ${metadataDate}` : ''}`;

  return (
    <div className={styles.header}>
      <Flex gap='small' align='center'>
        {BREADCRUMBS_STAGE_A.includes(stage) && (
          <Text
            size='4'
            weight={500}
            variant={
              BREADCRUMBS_STAGE_A_INACTIVE.includes(stage)
                ? 'tertiary'
                : 'primary'
            }
            data-test-id='back-to-inference-list-btn'
            onClick={onBackButtonClick}
          >
            Insights
          </Text>
        )}

        {stage === INFERENCE_STAGES.modeList && (
          <>
            <ChevronRightIcon />
            <Text size='4' weight={500} variant='primary'>
              New Insight
            </Text>
          </>
        )}

        {stage === INFERENCE_STAGES.inferenceInput && (
          <>
            <Text
              size='4'
              weight={500}
              variant='tertiary'
              onClick={onModelBackClick}
              data-test-id='back-to-model-list-btn'
            >
              New Insight
            </Text>

            {inputTitle && <ChevronRightIcon />}

            <Text size='4' weight={500} className={styles.InsightTitle}>
              {inputTitle}
            </Text>
          </>
        )}

        {stage === INFERENCE_STAGES.inferenceOutput &&
          title !== 'undefined' && (
            <>
              <ChevronRightIcon />
              <Text size='4' weight={500} variant='primary'>
                {title}
              </Text>
            </>
          )}
      </Flex>

      <IconButton
        size={3}
        onClick={onClose}
        data-test-id='close-insights-panel-btn'
      >
        <Cross1Icon />
      </IconButton>
    </div>
  );
};

export const InsightsOutputHeader = ({
  activeInsight,
  titleTailingContent = null
}) => {
  const title = activeInsight?.metadata?.block_title ?? '';

  const popupRef = useRef(null);

  return (
    <Flex align='stretch' justify='between' style={{ width: '100%' }}>
      <Flex gap='small'>
        <Text size={2} weight={500} variant='primary'>
          {title}
        </Text>
        {titleTailingContent}
      </Flex>

      <IconButton
        size={3}
        data-test-id='download-insight-btn'
        onClick={() => {
          popupRef.current?.setShowDialog();
        }}
      >
        <DownloadIcon />
      </IconButton>
      <DownloadInsightsPopup activeInsight={activeInsight} ref={popupRef} />
    </Flex>
  );
};
